module.exports = __webpack_public_path__ + "media/payments/downgrade-month-e0a7291e.png";